import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/common/ScrollToTop';
import LoadingSpinner from './components/common/LoadingSpinner';

// Lazy-load pages for code-splitting & performance
const Home = lazy(() => import('./pages/Home/Home'));
const About = lazy(() => import('./pages/About/About'));
const Services = lazy(() => import('./pages/Services/Services'));
const Architecture = lazy(() => import('./pages/Architecture/Architecture'));
const GlobalReach = lazy(() => import('./pages/GlobalReach/GlobalReach'));
const Products = lazy(() => import('./pages/Products/Products'));
const Events = lazy(() => import('./pages/Events/Events'));
const Publications = lazy(() => import('./pages/Publications/Publications'));
const PublicationDetail = lazy(() => import('./pages/Publications/PublicationDetail'));
const NonGuidewire = lazy(() => import('./pages/NonGuidewire/NonGuidewire'));
const Careers = lazy(() => import('./pages/Careers/Careers'));
const Team = lazy(() => import('./pages/Team/Team'));
const Contact = lazy(() => import('./pages/Contact/Contact'));
const ProductDevelopment = lazy(() => import('./pages/ProductDevelopment/ProductDevelopment'));
const CloudKitchen = lazy(() => import('./pages/CloudKitchen/CloudKitchen'));
const TrackingSmartCity = lazy(() => import('./pages/TrackingSmartCity/TrackingSmartCity'));
const CollectionApp = lazy(() => import('./pages/CollectionApp/CollectionApp'));

function App() {
  return (
    <div className="app">
      <ScrollToTop />
      <Header />
      <main>
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/architecture" element={<Architecture />} />
            <Route path="/global-reach" element={<GlobalReach />} />
            <Route path="/products" element={<Products />} />
            <Route path="/events" element={<Events />} />
            <Route path="/publications" element={<Publications />} />
            <Route path="/publications/:slug" element={<PublicationDetail />} />
            <Route path="/non-guidewire" element={<NonGuidewire />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/team" element={<Team />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/product-development" element={<ProductDevelopment />} />
            <Route path="/cloud-kitchen" element={<CloudKitchen />} />
            <Route path="/tracking-smart-city" element={<TrackingSmartCity />} />
            <Route path="/collection-management" element={<CollectionApp />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}

export default App;
